import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { PAYMENT_FILTER_OPTIONS } from "@shared/constants/payment-status-options";
import { SelectOption, TransactionOption, TransactionOptionsGroup } from "@shared/models/select-option.interface";
import { SetStatusAction } from "@store/actions/statusNetPayment.action";
import { AppState } from "@store/models/state.model";
import { BehaviorSubject } from "rxjs";

@Injectable({
	providedIn: "root"
})
export class CommonService {
	constructor(private store: Store<AppState>) {}

	private bulkSelection = new BehaviorSubject<boolean>(false);
	private bulkRelevantStatuses = new BehaviorSubject<string[]>([]);
	bulkRelevantStatuses$ = this.bulkRelevantStatuses.asObservable();
	isBulkSelected$ = this.bulkSelection.asObservable();

	/**FOR NEW NET/TPP PAYMENT STATUS FILTER */
	getTransactionOptions(): TransactionOptionsGroup[] {
		return PAYMENT_FILTER_OPTIONS;
	}

	getStatusOptions(): SelectOption[] {
		return [
			{ text: "Booked", value: "BOOKED" },
			{ text: "Created", value: "CREATED" },
			{ text: "Error", value: "ERROR" },
			{ text: "Failed", value: "FAILED,ATTEMPTS_LIMIT_EXCEEDED" },
			{ text: "Failed to book", value: "FAILED_TO_BOOK" },
			{ text: "Processed", value: "PROCESSED" },
			{ text: "Processing", value: "PROCESSING,PENDING" }
		];
	}

	getAllSelectableValues(): string[] {
		return [
			"statuses",
			"BOOKED",
			"CREATED",
			"ERROR",
			"FAILED,ATTEMPTS_LIMIT_EXCEEDED",
			"FAILED_TO_BOOK",
			"PROCESSED",
			"PROCESSING,PENDING"
		];
	}

	storeSelectionChange(statusArray: string[]): void {
		this.store.dispatch(
			new SetStatusAction({
				statusPayment: statusArray.length ? this.checkIfAllIsSelected(statusArray) : []
			})
		);
	}

	checkIfAllIsSelected(selection: string[]): string[] {
		return selection.includes("statuses") ? [""] : selection;
	}

	/**
	 * Set the bulk action selection status
	 * @param bulkSelected: bulk action selected object value
	 */
	isBulkSelected(bulkSelected: TransactionOption): void {
		this.bulkSelection.next(bulkSelected.group === "bulkOption");
		this.bulkRelevantStatuses.next(bulkSelected.statusesLinked!);
	}

	/**
	 * Format the subtitle for milestone pages and display run ID when available
	 * @param payGroupName
	 * @param payCycleName
	 * @param payrollCycleId
	 * @param milestoneGroup
	 * @returns subtitle to display on milestone pages
	 */
	formatMilestonePagesSubtitles(
		payGroupName: string,
		payCycleName: string,
		payrollCycleId: string | null,
		milestoneGroup: string
	): string {
		return payrollCycleId
			? `${payGroupName} - ${payCycleName} - ${payrollCycleId} - Group ${milestoneGroup}`
			: `${payGroupName} - ${payCycleName} - Group ${milestoneGroup}`;
	}
}
